/**
 * @generated SignedSource<<e5ad5f3e1a8e516084d10d63e10cfb62>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type templateEditorDialogFragment$variables = {
  categoryId?: number | null;
  designId?: number | null;
  modelID: string;
};
export type templateEditorDialogFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"templateEditorDialog_fragment">;
};
export type templateEditorDialogFragment = {
  response: templateEditorDialogFragment$data;
  variables: templateEditorDialogFragment$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "designId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelID"
  }
],
v1 = {
  "kind": "Variable",
  "name": "categoryId",
  "variableName": "categoryId"
},
v2 = {
  "kind": "Variable",
  "name": "designId",
  "variableName": "designId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "templateEditorDialogFragment",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/),
          (v2/*:: as any*/),
          {
            "kind": "Variable",
            "name": "modelID",
            "variableName": "modelID"
          }
        ],
        "kind": "FragmentSpread",
        "name": "templateEditorDialog_fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "templateEditorDialogFragment",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "modelID"
          }
        ],
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v1/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "concreteType": "TemplateEditorIframe",
            "kind": "LinkedField",
            "name": "iframeDesignUrl",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "largeUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mobileUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3c6d2164b0e36cd3e67a1202e138280",
    "id": null,
    "metadata": {},
    "name": "templateEditorDialogFragment",
    "operationKind": "query",
    "text": "query templateEditorDialogFragment(\n  $categoryId: Long\n  $designId: Long\n  $modelID: ID!\n) {\n  ...templateEditorDialog_fragment_1YZhoM\n}\n\nfragment templateEditorDialog_fragment_1YZhoM on Query {\n  model(id: $modelID) {\n    id\n    name\n    code\n    iframeDesignUrl(designId: $designId, categoryId: $categoryId) {\n      largeUrl\n      mobileUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ad1e9b064e711f990426c57cf4bbd17";

export default node;
